import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { emptyCart, setIsCartOpen } from "../../../redux/features/cartState";
import ProcessingBar from "utils/Processingbar";

const BusinessSidebar = () => {
  const cart = useSelector((state) => state.cart.cart);
  const operatorInfo = useSelector((state) => state.cart.contactInfo);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const totalPrice = cart.reduce(
    (sum, item) => sum + item?.price * item?.count,
    0
  );

  const [loading, setLoading] = useState(false);

  const checkoutHandler = () => {
    setLoading(true);
    setTimeout(() => {
      dispatch(setIsCartOpen(false));
      navigate("/checkoutprocess");
      setLoading(false);
    }, 1500);
  };

  const cartWithOperator = cart.map((item) => ({
    ...item,
    operatorInfo: operatorInfo[item?.operator] || null,
  }));

  const groupedItems = cartWithOperator.reduce((acc, item) => {
    if (!acc[item?.operator]) acc[item?.operator] = [];
    acc[item?.operator].push(item);
    return acc;
  }, {});

  const totalPriceByOperator = (items) =>
    items.reduce((acc, item) => {
      acc[item?.operator] =
        (acc[item?.operator] || 0) + item?.price * item?.count;
      return acc;
    }, {});

  const totalPrices = totalPriceByOperator(cartWithOperator);

  return (
    <div className="relative w-full lg:w-1/3 rounded-xl border border-border shadow max-h-[calc(90vh-5rem)] bg-dry sticky top-20 ">
      <div className="overflow-y-auto p-6 space-y-6 pb-48 max-h-[calc(90vh-13rem)] scrollbar-thin">
        {Object.keys(groupedItems).map((operatorId) => {
          const operator = groupedItems[operatorId][0]?.operatorInfo;
          const items = groupedItems[operatorId];
          const total = totalPrices[operatorId] || 0;

          return (
            <div
              key={operatorId}
              className="space-y-6 border border-border bg-drylight rounded-xl p-3"
            >
              <div className="flex items-center gap-3">
                <img
                  src={operator?.photo || ""}
                  alt="operator"
                  className="w-10 h-10 rounded-full border"
                />
                <div>
                  <p className="text-sm font-semibold text-red-500">
                    {operator?.name || "Unknown"}
                  </p>
                </div>
              </div>

              <div className="space-y-2">
                <p className="text-green-500 font-medium text-[12px]">
                  ⏰ Open until {operator?.openUntil || "6:00 pm"}
                </p>
                <p className="text-[12px] text-textGray">
                  📍 {operator?.address || "No address provided"}
                </p>
                <a
                  href={operator?.address || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-purple-600 underline text-sm"
                >
                  Get directions
                </a>
              </div>

              <div className="bg-neutral-100 dark:bg-neutral-700 p-3 rounded-md space-y-2">
                {items.map((item) => (
                  <div key={item._id} className="flex justify-between text-sm">
                    <span className="text-[12px] text-gray-700 dark:text-text capitalize">
                      {item.title}{" "}
                      <span className="font-semibold">× {item.count}</span>
                    </span>
                    <span className="text-gray-900 dark:text-text">
                      ${(item.price * item.count).toFixed(2)}
                    </span>
                  </div>
                ))}
                <div className="flex justify-between font-semibold pt-2 text-white">
                  <span>Total</span>
                  <span>${total.toFixed(2)}</span>
                </div>
              </div>

              <div className="space-y-2 text-[12px]">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">Memberships</p>
                    <p className="text-gray-500">
                      Buy a bundle of appointments.
                    </p>
                  </div>
                  <button className="border px-4 py-1 rounded-full font-semibold">
                    Buy
                  </button>
                </div>
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">Vouchers</p>
                    <p className="text-gray-500">
                      Treat yourself or a friend to future visits.
                    </p>
                  </div>
                  <button className="border px-4 py-1 rounded-full font-semibold">
                    Buy
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="absolute bottom-0 left-0 w-full bg-dry border-t px-4 py-4 z-10">
        <div className="flex justify-between items-center text-lg text-white font-bold border-b border-white pb-2 mb-3">
          <span>TOTAL</span>
          <span>${totalPrice.toFixed(2)}</span>
        </div>

        <div className="flex justify-between gap-3">
          <button
            className="flex-1 rounded-full bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 transition"
            onClick={() => dispatch(emptyCart())}
          >
            CLEAR
          </button>
          <button
            className="flex-1 rounded-full bg-red-500 hover:bg-red-600 text-white font-bold py-2 transition"
            onClick={checkoutHandler}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <ProcessingBar />
              </div>
            ) : user ? (
              "Check Out"
            ) : (
              "Login to Check Out"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessSidebar;

// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { emptyCart, setIsCartOpen } from "../../../redux/features/cartState";
// import ProcessingBar from "utils/Processingbar";

// const BusinessSidebar = () => {
//   const cart = useSelector((state) => state.cart.cart);
//   const operatorInfo = useSelector((state) => state.cart.contactInfo);

//   const dispatch = useDispatch();
//   const user = useSelector((state) => state.auth.user);
//   const navigate = useNavigate();

//   const totalPrice = cart.reduce(
//     (sum, item) => sum + item.price * item.count,
//     0
//   );

//   // Optional loading state
//   const [loading, setLoading] = useState(false);

//   const checkoutHandler = () => {
//     setLoading(true);
//     setTimeout(() => {
//       dispatch(setIsCartOpen(false));
//       navigate("/checkoutprocess");
//       setLoading(false);
//     }, 1500);
//   };

//   const cartWithOperator = cart.map((item) => ({
//     ...item,
//     operatorInfo: operatorInfo[item.operator] || null,
//   }));

//   const groupedItems = cartWithOperator.reduce((acc, item) => {
//     if (!acc[item.operator]) acc[item.operator] = [];
//     acc[item.operator].push(item);
//     return acc;
//   }, {});

//   const totalPriceByOperator = (items) =>
//     items.reduce((acc, item) => {
//       acc[item.operator] = (acc[item.operator] || 0) + item.price * item.count;
//       return acc;
//     }, {});

//   const totalPrices = totalPriceByOperator(cartWithOperator);

//   return (
//     <div className="w-full lg:w-1/3 rounded-xl border border-border shadow p-6 h-fit max-h-[calc(80vh-5rem)] overflow-y-auto sticky top-12 bg-dry space-y-6 scrollbar-thin auto-scroll-y">
//       {Object.keys(groupedItems).map((operatorId) => {
//         const operator = groupedItems[operatorId][0]?.operatorInfo;
//         const items = groupedItems[operatorId];
//         const total = totalPrices[operatorId] || 0;

//         return (
//           <div
//             key={operatorId}
//             className="space-y-6 border border-border bg-drylight rounded-xl p-3"
//           >
//             {/* Operator Info */}
//             <div className="flex items-center gap-3">
//               <img
//                 src={operator?.photo || ""}
//                 alt="operator"
//                 className="w-10 h-10 rounded-full border"
//               />
//               <div>
//                 <p className="text-sm font-semibold text-red-500">
//                   {operator?.name || "Unknown"}
//                 </p>
//               </div>
//             </div>

//             {/* Booking Info */}
//             <div className="space-y-2">
//               <p className="text-green-500 font-medium text-[12px]">
//                 ⏰ Open until {operator?.openUntil || "6:00 pm"}
//               </p>
//               <p className="text-[12px] text-textGray">
//                 📍 {operator?.address || "No address provided"}
//               </p>
//               <a
//                 href={operator?.address || "#"}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-purple-600 underline text-sm"
//               >
//                 Get directions
//               </a>
//             </div>

//             {/* Cart Items */}
//             <div className="bg-neutral-100 dark:bg-neutral-700 p-3 rounded-md space-y-2">
//               {items.map((item) => (
//                 <div key={item._id} className="flex justify-between text-sm ">
//                   <span className="text-[12px] text-gray-700 dark:text-text capitalize">
//                     {item.title}{" "}
//                     <span className="font-semibold">× {item.count}</span>
//                   </span>
//                   <span className="text-gray-900 dark:text-text">
//                     ${(item.price * item.count).toFixed(2)}
//                   </span>
//                 </div>
//               ))}
//               <div className="flex justify-between font-semibold pt-2 text-white">
//                 <span>Total</span>
//                 <span>${total.toFixed(2)}</span>
//               </div>
//             </div>

//             {/* Memberships and Vouchers */}
//             <div className="space-y-2 text-[12px]">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="font-medium">Memberships</p>
//                   <p className="text-gray-500">Buy a bundle of appointments.</p>
//                 </div>
//                 <button className="border px-4 py-1 rounded-full font-semibold">
//                   Buy
//                 </button>
//               </div>
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="font-medium">Vouchers</p>
//                   <p className="text-gray-500">
//                     Treat yourself or a friend to future visits.
//                   </p>
//                 </div>
//                 <button className="border px-4 py-1 rounded-full font-semibold">
//                   Buy
//                 </button>
//               </div>
//             </div>
//           </div>
//         );
//       })}

//       <div className="text-black p-4 border-t mt-4">
//         <div className="flex justify-between items-center text-sm text-gray-500 dark:text-neutral-300 mb-1">
//           <span className="font-semibold text-white">Sub-Total</span>
//           <span className="font-semibold text-white">
//             ${totalPrice.toFixed(2)}
//           </span>
//         </div>
//         <div className="flex justify-between items-center text-sm text-gray-400 dark:text-neutral-400 mb-4">
//           <span>GST (15% included)</span>
//           <span>${((totalPrice * 3) / 23).toFixed(2)}</span>
//         </div>

//         {/* <div className="flex justify-between items-center text-lg text-white font-bold border-t border-white pt-2 mb-4">
//           <span>TOTAL</span>
//           <span>${totalPrice.toFixed(2)}</span>
//         </div>

//         <div className="flex justify-between gap-3">
//           <button
//             className="flex-1 rounded-full bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 transition"
//             onClick={() => dispatch(emptyCart())}
//           >
//             CLEAR
//           </button>
//           <button
//             className="flex-1 rounded-full bg-red-500 hover:bg-red-600 text-white font-bold py-2 transition"
//             onClick={checkoutHandler}
//           >
//             {loading ? (
//               <div className="flex items-center justify-center">
//                 <ProcessingBar />
//               </div>
//             ) : user ? (
//               "Check Out"
//             ) : (
//               "Login to Check Out"
//             )}
//           </button>
//         </div> */}
//       </div>
//       <div className="absolute bottom-0 left-0 w-full bg-dry border-t px-4 py-4 z-10">
//         <div className="flex justify-between items-center text-lg text-white font-bold border-b border-white pb-2 mb-3">
//           <span>TOTAL</span>
//           <span>${totalPrice.toFixed(2)}</span>
//         </div>

//         <div className="flex justify-between gap-3">
//           <button
//             className="flex-1 rounded-full bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 transition"
//             onClick={() => dispatch(emptyCart())}
//           >
//             CLEAR
//           </button>
//           <button
//             className="flex-1 rounded-full bg-red-500 hover:bg-red-600 text-white font-bold py-2 transition"
//             onClick={checkoutHandler}
//           >
//             {loading ? (
//               <div className="flex items-center justify-center">
//                 <ProcessingBar />
//               </div>
//             ) : user ? (
//               "Check Out"
//             ) : (
//               "Login to Check Out"
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BusinessSidebar;
